<script>
    import { store } from '../../Store.svelte';
    import { isTelephony } from '../../Util.svelte';
    import PhonePortability from './PhonePortability.svelte';
    import { env, principalStreamersNames } from '../../Environment.svelte';
    import IzziMovilPlan from '../movil/IzziMovilPlan.svelte';

    let promoCode = $store.requestedServices.product.promoCode;
    let dobleDescuento_dobleMegasPromo,
        dobleDescuentoPromo,
        traeLinea_superDescuentoPromo,
        superDescuento_dobleMegasPromo,
        extensionTvDescuentoPromo,
        dobleDescuento_masMegasPromo,
        superDescuentoPromo,
        traeLinea_superDescuentoSJRPromo = null;
    if (promoCode != null) {
        dobleDescuento_dobleMegasPromo = promoCode.includes(
            'dobleDescuento_dobleMegas'
        );
        dobleDescuento_masMegasPromo = promoCode.includes(
            'dobleDescuento_masMegas'
        );
        dobleDescuentoPromo = promoCode.includes('dobleDescuento');
        traeLinea_superDescuentoPromo = promoCode.includes(
            'traeLinea_superDescuento'
        );
        superDescuento_dobleMegasPromo = promoCode.includes(
            'superDescuento_dobleMegas'
        );
        extensionTvDescuentoPromo = promoCode.includes('extensionTvDescuento');
        superDescuentoPromo = promoCode.includes('superDescuento');
        traeLinea_superDescuentoSJRPromo = promoCode.includes(
            'traeLinea_superDescuentoSJR'
        );
    }
    let promoText = '';
    let promoFin = false;
    if ($store.requestedServices.product.promoCode) {
        if (dobleDescuento_dobleMegasPromo) {
            promoText += '<span>Doble descuento con el Doble de Megas</span>';
            promoFin = true;
        } else if (dobleDescuento_masMegasPromo) {
            promoText += '<span>Doble descuento con más Megas</span>';
            promoFin = true;
        } else if (dobleDescuentoPromo) {
            promoText += '<span>Doble descuento</span>';
            promoFin = true;
        } else if (superDescuento_dobleMegasPromo) {
            promoText += '<span>Súper descuento con el Doble de Megas</span>';
            promoFin = true;
        } else if (
            traeLinea_superDescuentoPromo ||
            traeLinea_superDescuentoSJRPromo
        ) {
            promoText +=
                '<span>Trae tu línea y obtén un súper descuento</span>';
            promoFin = true;
        } else if (extensionTvDescuentoPromo) {
            promoText +=
                '<span>1 extensión izzitv adicional sin costo durante 12 meses</span>';
            promoFin = true;
        } else if (superDescuentoPromo) {
            promoText +=
                '<span>Obtén un Súper descuento y navega con Más Megas</span>';
            promoFin = true;
        }
    }

    let productName = $store.requestedServices.product.title;
    let descripcionProducto;
    let isVix,
        isNetflixAdds,
        isNetflix1S,
        isNetflix2S,
        isNetflix4S,
        isHBO = false;
    let lastNetflix = principalStreamersNames.at(6);

    store.subscribe((value) => {
        descripcionProducto =
            $store.requestedServices.product?.description + '.';
        productName = $store.requestedServices.product?.title;
        let omitir =
            $store.requestedServices.product?.productFamily === 'residencial' &&
            $store.requestedServices.product?.vel < 100;
        if (!omitir) {
            const vix = principalStreamersNames.at(0);
            const netflixAdds = principalStreamersNames.at(6);
            const netflix1S = principalStreamersNames.at(5);
            const netflix2S = principalStreamersNames.at(1);
            const netflix4S = principalStreamersNames.at(2);
            const hboName = principalStreamersNames.at(4);
            const hboName2 = principalStreamersNames.at(7);
            const maxAdd = principalStreamersNames.at(8);

            isVix = modifyAtributes(vix, $store.requestedServices.isVix);
            isNetflixAdds = modifyAtributes(
                netflixAdds,
                $store.requestedServices.isNetflix
            );
            isNetflix1S = modifyAtributes(
                netflix1S,
                $store.requestedServices.isNetflix
            );
            isNetflix2S = modifyAtributes(
                netflix2S,
                $store.requestedServices.isNetflix
            );
            isNetflix4S = modifyAtributes(
                netflix4S,
                $store.requestedServices.isNetflix
            );
            isHBO = modifyAtributes(hboName, $store.requestedServices.isHBO);
            isHBO = modifyAtributes(hboName2, $store.requestedServices.isHBO);
            isHBO = modifyAtributes(maxAdd, $store.requestedServices.isHBOAdds);

            lastNetflix = isNetflixAdds
                ? principalStreamersNames.at(6)
                : isNetflix2S
                  ? principalStreamersNames.at(1)
                  : isNetflix1S
                    ? principalStreamersNames.at(5)
                    : principalStreamersNames.at(2);
        }
    });

    function modifyAtributes(itemName, isModificable) {
        let item = isPrincipal(itemName, isModificable);
        if (item) {
            productName += $store.requestedServices.isCombo
                ? productName.includes('con izzi COMBO')
                    ? ''
                    : ' con izzi COMBO'
                : '';
            descripcionProducto +=
                ' ' +
                (item.extra.descriptionOTT ? item.extra.descriptionOTT : '');
            return true;
        }
        return false;
    }

    function isPrincipal(itemName, isModificable) {
        let item = isModificable
            ? $store.requestedServices.channelExtras.find(
                  (extra) => extra.extra.extName == itemName
              )
            : null;
        return item;
    }

    const netflixLogo = () => {
        const name =
            $store.requestedServices.channelExtras.find(
                (item) =>
                    item.combo &&
                    item.extra.extName.toLowerCase().includes('netflix')
            ) ?? null;
        if (name) return env.logosAddOns[name.extra.title];

        return '';
    };

    const maxLogo = () => {
        const name =
            $store.requestedServices.channelExtras.find((item) =>
                item.extra.extName
                    .toLowerCase()
                    .includes('hazlo estandar para max basico')
            ) ?? null;
        if (name) return '/assets/img/logos/hbomax-logo.svg';

        return '/assets/img/logos/hbomax-add-logo.svg';
    };

    let logoNeflix = '';
    let logoMax = '';
    $: if ($store.requestedServices.channelExtras) {
        logoNeflix = netflixLogo();
        logoMax = maxLogo();
    }
</script>

<div class="panel panel--no-mobile m-b-25">
    {#if ['movil'].includes($store.requestedServices.product.productFamily)}
        <div class="pure-g align-items-center">
            <div class="sm-m-b-20">
                <div class="h2 text-fs-20 fw-semibold m-b-25">
                    Tus productos
                </div>
                <p>
                    El plan principal de izzi móvil que seleccionaste es el
                    siguiente:
                </p>
            </div>
        </div>
        <IzziMovilPlan item={$store.requestedServices.product} isPrincipal />
    {:else}
        <div class="h2 text-fs-23 fw-semibold m-b-10">{productName}</div>
        {#if $store.requestedServices.product.description != null}
            <p>{@html descripcionProducto}</p>
        {/if}
        {#if promoFin == true}
            <div class="promo-badge m-b-20">
                <span>¡PROMOCIÓN! {@html promoText}</span>
            </div>
        {/if}
        {#if !$store.settings.advancedConfigurationMode && isTelephony($store.requestedServices.product.productFamily)}
            <div class="m-b-40" />
            <PhonePortability />
        {/if}
        {#if $store.requestedServices.isCombo}
            <div class="pure-g align-items-center m-b-25">
                <div class="pure-u-2-3">
                    <div class="h2 text-fs-20 fw-semibold">izzi COMBO</div>
                </div>
                <div class="pure-u-1-3 text-right">
                    <p class="m-b-0">Obligatorio</p>
                </div>
            </div>
            <p class="m-b-10">Tu izzi COMBO incluye:</p>
            <div class="addons-grid">
                {#if $store.requestedServices.isVix}
                    <div class="addon izzicombo-addon vix-addon">
                        <input
                            type="checkbox"
                            name=""
                            id="addon_vix"
                            checked
                            disabled
                        />
                        <label for="addon_vix" class="addon-label">
                            <span class="addon-check__indicator"
                                ><img
                                    src="/assets/img/icons/check.svg"
                                    alt=""
                                    aria-hidden="true"
                                /></span
                            >
                            <div class="addon-name">
                                <img
                                    src="/assets/img/logos/vixpremium-white-logo.svg"
                                    alt=""
                                />
                            </div>
                        </label>
                    </div>
                {/if}
                {#if $store.requestedServices.isHBOAdds}
                    <div class="addon izzicombo-addon hbomax-addon">
                        <input
                            type="checkbox"
                            name=""
                            id="addon_hbo"
                            checked
                            disabled
                        />
                        <label for="addon_hbo" class="addon-label">
                            <span class="addon-check__indicator"
                                ><img
                                    src="/assets/img/icons/check.svg"
                                    alt=""
                                    aria-hidden="true"
                                /></span
                            >
                            <div class="addon-name">
                                <img src={logoMax} alt="" />
                            </div>
                        </label>
                    </div>
                {/if}
                {#if $store.requestedServices.isNetflix}
                    <div class="addon izzicombo-addon netflix-addon">
                        <input
                            type="checkbox"
                            name=""
                            id="addon_netflix"
                            checked
                            disabled
                        />
                        <label for="addon_netflix" class="addon-label">
                            <span class="addon-check__indicator"
                                ><img
                                    src="/assets/img/icons/check.svg"
                                    alt=""
                                    aria-hidden="true"
                                /></span
                            >
                            <div class="addon-name">
                                <img src={logoNeflix} alt="" />
                            </div>
                        </label>
                    </div>
                {/if}
                {#if $store.requestedServices.isHBO}
                    <div class="addon izzicombo-addon hbomax-addon">
                        <input
                            type="checkbox"
                            name=""
                            id="addon_hbo"
                            checked
                            disabled
                        />
                        <label for="addon_hbo" class="addon-label">
                            <span class="addon-check__indicator"
                                ><img
                                    src="/assets/img/icons/check.svg"
                                    alt=""
                                    aria-hidden="true"
                                /></span
                            >
                            <div class="addon-name">
                                <img
                                    src="/assets/img/logos/hbomax-logo.svg"
                                    alt=""
                                />
                            </div>
                        </label>
                    </div>
                {/if}
            </div>
        {/if}
    {/if}
</div>
